'use client';

import { DotLottiePlayer } from '@dotlottie/react-player';
import mascotAnimationFriendlySrc from '../assets/mascot-animation-friendly.lottie';
type Props = {
  autoplay?: boolean;
};
export const MascotAnimationFriendly = ({
  autoplay = true
}: Props) => <DotLottiePlayer src={mascotAnimationFriendlySrc} loop autoplay={autoplay} data-sentry-element="DotLottiePlayer" data-sentry-component="MascotAnimationFriendly" data-sentry-source-file="MascotAnimationFriendly.tsx" />;